import queryString from 'query-string';
import UiElement from '../../../shared/ui-element/ui-element';
import EmailSubscription from '../email-subscription/email-subscription';
import Navigation from '../navigation/navigation';
import Footer from '../footer/footer';
import FontsLoader from '../../utils/fonts-loader';
import ClickTracker from '../../../shared/click-tracker/click-tracker';
import SignupModal from '../signup-modal/signup-modal';
import CookieBanner from '../cookie-banner/cookie-banner';
import RedirectTo from '../redirect-to/redirect-to';
import analytics from '../../../shared/analytics';

import fontsConfig from '../../config/font-config';

import '../../main.scss';

class BasePage extends UiElement {
  signupModalOptions = {
    hideCloseBtn: false,
  };

  constructor() {
    super();

    this.signupModal = new SignupModal();
    this.analytics = analytics;
  }

  onInit() {
    const fontsLoader = new FontsLoader(fontsConfig);

    fontsLoader.load();
    new EmailSubscription({rootElement: '.js-base-subscription-form'}).init();
    new Navigation().init();
    new ClickTracker().init();
    new CookieBanner().init();
    new RedirectTo().init();
    new Footer().init();

    this.signupModal.init();
    this.setSignupModalOptions();
    this.initSignUpButtons();
    this.openSignupModalIfBundleOrSingleAppFlow();
    this.initABNTests();
  }

  setSignupModalOptions() {
    const query = queryString.parse(window.location.search);

    if ('hideModalCloseBtn' in query) {
      this.signupModalOptions = {...this.signupModalOptions, hideCloseBtn: true};
    }
  }

  initSignUpButtons() {
    const buttons = document.querySelectorAll('[data-signup-button]');

    [].forEach.call(buttons, (button) => {
      button.addEventListener('click', this.handleSignUpButtonClick);
    });
  }

  handleSignUpButtonClick = (e) => {
    const {tierType, signupHideSocials} = e.currentTarget.dataset;

    this.signupModal.open({...this.signupModalOptions, tierType, signupHideSocials});
  };

  openSignupModalIfBundleOrSingleAppFlow() {
    const query = queryString.parse(window.location.search);

    if (query.bundleId || query.appId) {
      this.signupModal.open(this.signupModalOptions);
    }
  }

  initABNTests() {
    const testData = window.ABN_TESTS_DATA || {};
    this.analytics.setTestResults(testData.feature_flags || [], testData.test_groups || []);
  }
}

export default BasePage;
